'use client';

import Bed from '@public/svg/bed.svg?component';
import ChartSine from '@public/svg/chart-sine.svg?component';
import Dumbbell from '@public/svg/dumbbell.svg?component';
import PotFood from '@public/svg/pot-food.svg?component';

export const SwabKitProductDetailsLabCertified: React.FC = () => {
  return (
    <div className="mb-8">
      <div className="tracking-[-0.48px] font-light mb-8">
        Our
        <span className="font-normal mx-1">CLIA-certified, CAP-accredited</span>
        Lab analyzes 60 polymorphisms to identify
        <span className="font-normal mx-1">13 key traits</span>
        that create your personalized wellness plan. You’ll find out:
      </div>

      <div className="grid xl:grid-cols-2 grid-cols-1 gap-x-0 gap-y-3">
        <div className="flex justify-start items-center gap-2">
          <div className="px-3.5 py-4 border border-1 border-badge-gray rounded-[78px]">
            <Dumbbell />
          </div>
          <div>Your best type of exercise</div>
        </div>
        <div className="flex justify-start items-center gap-2">
          <div className="px-3.5 py-4 border border-1 border-badge-gray rounded-[78px]">
            <PotFood />
          </div>
          <div>Your unique nutritional needs</div>
        </div>
        <div className="flex justify-start items-center gap-2">
          <div className="px-3.5 py-4 border border-1 border-badge-gray rounded-[78px]">
            <ChartSine />
          </div>
          <div>Your weight loss roadmap</div>
        </div>
        <div className="flex justify-start items-center gap-2">
          <div className="px-3.5 py-4 border border-1 border-badge-gray rounded-[78px]">
            <Bed />
          </div>
          <div>Your recovery tendencies</div>
        </div>
      </div>
    </div>
  );
};
